export var PreviewMode;
(function (PreviewMode) {
    PreviewMode[PreviewMode["PendingUrl"] = 0] = "PendingUrl";
    PreviewMode[PreviewMode["View"] = 1] = "View";
    PreviewMode[PreviewMode["Edit"] = 2] = "Edit";
    PreviewMode[PreviewMode["Saving"] = 3] = "Saving";
    PreviewMode[PreviewMode["Copying"] = 4] = "Copying";
    PreviewMode[PreviewMode["Error"] = 5] = "Error";
    PreviewMode[PreviewMode["NoUrl"] = 6] = "NoUrl";
})(PreviewMode || (PreviewMode = {}));
export var SaveToCloudStatus;
(function (SaveToCloudStatus) {
    SaveToCloudStatus[SaveToCloudStatus["disabled"] = 0] = "disabled";
    SaveToCloudStatus[SaveToCloudStatus["available"] = 1] = "available";
    SaveToCloudStatus[SaveToCloudStatus["saving"] = 2] = "saving";
    SaveToCloudStatus[SaveToCloudStatus["succeeded"] = 3] = "succeeded";
    SaveToCloudStatus[SaveToCloudStatus["failed"] = 4] = "failed";
})(SaveToCloudStatus || (SaveToCloudStatus = {}));
export { AddToCalendarStatus };
//# sourceMappingURL=PreviewPaneState.js.map